import request from '@/utils/request';
import Resource from '@/api/resource';
import JSONbig from 'json-bigint';
class EventManager extends Resource {
  constructor() {
    super('tool/eventManager/jrtt');
  }

  /** 获取广告主下的资产列表 */
  getAssetsListApi(data) {
    return request({
      url: `/${this.uri}/assetsList`,
      method: 'get',
      params: data,
      transformResponse: (response) => {
        const is_mini = data?.asset_type === 'MINI_PROGRAME';
        return is_mini ? JSONbig({ storeAsString: true }).parse(response) : JSON.parse(response);
      },
    });
  }

  /** 获取资产下已创建事件列表 */
  getEventListApi(data) {
    return request({
      url: `/${this.uri}/eventList`,
      method: 'get',
      params: data,
    });
  }

  /** 获取事件优化目标 */
  getEventConvertApi(data) {
    return request({
      url: `/${this.uri}/eventConvert`,
      method: 'get',
      params: data,
    });
  }

  /** 获取优化目标选项 */
  getConvertApi(data) {
    return request({
      url: `/${this.uri}/convert`,
      method: 'get',
      params: data,
    });
  }

  /** 同步事件资产 */
  pullEventAssetsApi(data) {
    return request({
      url: `/${this.uri}/pull`,
      method: 'get',
      params: data,
    });
  }
}
export { EventManager as default };
